import { render } from "./DbTableEditPage.vue?vue&type=template&id=8549f93a"
import script from "./DbTableEditPage.vue?vue&type=script&lang=js"
export * from "./DbTableEditPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__